import { render, staticRenderFns } from "./TutorsDetails.vue?vue&type=template&id=e9b362b2&scoped=true"
import script from "./TutorsDetails.vue?vue&type=script&lang=js"
export * from "./TutorsDetails.vue?vue&type=script&lang=js"
import style0 from "./TutorsDetails.vue?vue&type=style&index=0&id=e9b362b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b362b2",
  null
  
)

export default component.exports